import { IconDoubleRight, IconExclamationCircle, IconMoreVertical, IconSearch } from '@arco-design/web-react/icon'
import React, { useEffect, useRef, useState } from 'react'
import './VoiceList.less'
import manImg from '@/assets/create-space/man.png'
import womenImg from '@/assets/create-space/women.png'
import renameImg from '@/assets/create-space/rename.png'
import voiceActiveImg from '@/assets/create-space/voice-active.png'
import voiceDisabledImg from '@/assets/create-space/voice-disabled.png'
import playVoiceImg from '@/assets/create-space/voice-play.png'
import voiceBgImg from '@/assets/create-space/clone-bg.png'
import playingImg from '@/assets/create-space/mp3-play.gif'
import { Dropdown, Empty, Form, Input, Menu, Message, Modal, Spin, Tooltip } from '@arco-design/web-react'
import { getVoiceListApi, getVoiceTimesApi, renameVoiceApi } from '@/services/createSpace/voice'
import { useNavigate } from 'react-router-dom'
import useAudioPlay from './useAudioPlay'
import dayjs from 'dayjs';

enum Estatus {
  '成功' = 1,
  '失败',
  '合成中'
}
export default function VoiceClone() {
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [playId, setPlayId] = useState(0)
  const navigate = useNavigate()
  const [dataSource, setDataSource] = useState([])
  const dataRef = useRef([])
  const [visible, setVisible] = useState(false)
  const [renameId, setRenameId] = useState(0)
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const navigator = useNavigate();
  const {
    isPlaying,
    stopAudio,
    playAudio,
    loading: isLoading,
  } = useAudioPlay();
  const handleRetry = (row) => {
    if (row.train_times > 9) return
    localStorage.setItem('voice-retry', JSON.stringify(row))
    navigate(`/voice-detail?id=${row.id}`)
  }
  const handleRename = (row) => {
    setRenameId(row.id)
    setVisible(true)
    form.setFieldValue('name', row.name)
  }
  const DropList = ({item}) => {
    const imgUrl = item.train_times < 10 ? voiceActiveImg : voiceDisabledImg
    return (
      <div className="clone-drop-list">
        <div className="clone-drop-item" onClick={() => handleRename(item)}>
          <img src={renameImg} alt="" />
          <span>重命名</span>
        </div>
        <div className="clone-drop-item" onClick={() => handleRetry(item)}>
          {
            item.train_times < 10 ?
            <><img src={imgUrl} alt="" /><span>重新录制</span></> :
            <Tooltip content="您的重新录制次数已用完">
                <div style={{display: 'flex', alignItems: 'center'}} className='disabled-text'>
                  <img src={imgUrl} alt="" />
                  <span>重新录制</span>
                </div>
            </Tooltip>
          }
        </div>
      </div>
    )
  }
  const handlePlay = (item) => {
    if (isLoading) return;
    if (item.train_status === 2) {
      localStorage.setItem('voice-retry', JSON.stringify(item))
      navigate(`/voice-detail?id=${item.id}`)
      return
    }
    setPlayId(item.id)
    playAudio({
      speaker_id: item.speaker_id,
      voice_type: 'custom'
    })
  }
  const handlePause = () => {
    stopAudio()
  }
  const handleToDetail = () => {
    getVoiceTimesApi().then(res => {
      if (res.times) {
        navigate('/voice-detail')
      } else {
        Message.error('您的克隆声音剩余次数不足')
      }
    })
  }
  const onOk = () => {
    form.validate().then(formData => {
      setConfirmLoading(true)
      renameVoiceApi({id: renameId, name: formData.name}).then(() => {
        setVisible(false)
        setConfirmLoading(false)
        const cloneList = JSON.parse(JSON.stringify(dataSource))
        cloneList.forEach((item) => {
          if (item.id === renameId) {
            item.name = formData.name
          }
        })
        setDataSource(cloneList)
      }).catch(() => {
        setConfirmLoading(false)
      })
    })
  }
  const getList = () => {
    setLoading(true)
    getVoiceListApi().then(res => {
      dataRef.current = res?.items || []
      setDataSource(res?.items || [])
    }).finally(() => {
      setLoading(false)
    })
  }
  const handleSearch = (e) => {
    if (!e.target.value) {
      setDataSource(dataRef.current)
    } else {
      const result = dataRef.current.filter((i) => i.name.match(e.target.value))
      setDataSource(result)
    }
  }
  useEffect(() => {
    getList()
  }, [])
  return (
    <div className="voice-clone-index">
      <div className="voice-clone-header">
        <div className="flex-clone">
          <div className="voice-left">
            <div className="voice-title">
              音色克隆
            </div>
            <div className="voice-desc">
              仅用一句话便可实现声音复刻，极速拥有专属AI定制音色。声音真实、自然、流畅，极大节约成本，提升合成效率
            </div>
          </div>
          <div className="voice-right">
            <div className="btn-wrapper">
              <div className="clone-btn" onClick={handleToDetail}>
                <span>点击克隆</span>
                <IconDoubleRight style={{color: '#165DFF'}}/>
              </div>
            </div>
            <img src={voiceBgImg} alt="" style={{height: '100%'}}/>
          </div>

        </div>
      </div>
      <div className={'header-title'}><span onClick={() => {
        navigator('/creative-tool', {
          replace: true
        })
      }}>创作工具 / </span> <span>音色克隆</span></div>
      <div className="voice-clone-search">
        <div className="clone-text">我的克隆</div>
        <Input
          size="large"
          style={{width: 350}}
          prefix={<IconSearch/>}
          placeholder='请输入音色名称'
          onPressEnter={handleSearch}
        />
      </div>
      <Spin loading={loading} style={{width: '100%'}}>
        <div className="clone-list">
          {
            dataSource.map((item) => {
              return (
                <div className="clone-item" key={item.id}>
                  <div className="img">
                    <img src={item.url || (item.gender === 1 ? manImg : womenImg)} alt=""/>
                    <div className={`img-black ${(playId === item.id && isPlaying) ? 'play' : ''}`}>
                      {
                        (playId === item.id && isPlaying) ?
                          <img onClick={handlePause} src={playingImg} alt=""/> :
                          <>
                            {
                              (playId === item.id && isLoading) ? <Spin/> :
                                <img src={playVoiceImg} onClick={() => handlePlay(item)} alt=""/>
                            }
                          </>
                      }
                    </div>
                  </div>
                  <div className="item-name">
                    <div className="name-text">{item.name}</div>
                    <Dropdown trigger='click' droplist={
                      <DropList item={item}/>
                    } position='bl'>
                      <IconMoreVertical style={{cursor: 'pointer'}}/>
                    </Dropdown>
                  </div>
                  <div className="item-time">{dayjs(item.updated_at * 1000).format('YYYY/MM/DD HH:mm:ss')}</div>
                  <div className={`clone-tag color-${item.train_status}`}>
                    {item.train_status === 2 && <Tooltip content={item.error_msg}>
                        <IconExclamationCircle style={{marginRight: '3px'}}/>
                    </Tooltip>}
                    <span>{Estatus[item.train_status]}</span>
                  </div>
                </div>
              )
            })
          }
          {
            dataSource.length < 1 &&
              <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}><Empty/>
              </div>
          }
          {/* <div className="clone-item">
          <div className="img">
            <img src={cloneImg} alt="" />
          </div>
          <div className="item-name">
            <div className="name-text">三亚海边三天莎婚纱嘎嘎是</div>
            <Dropdown droplist={
              <DropList/>
            } position='bl'>
              <IconMoreVertical style={{cursor: 'pointer'}}/>
            </Dropdown>
          </div>
          <div className="item-time">2025/01/21 10:10:10</div>
          <div className="clone-tag color-2">
            <Tooltip content="错误的信息啊">
              <IconExclamationCircle style={{marginRight: '3px'}} />
            </Tooltip>
            <span>成功</span>
          </div>
        </div> */}
        </div>
      </Spin>
      <Modal
        style={{width: '700px'}}
        visible={visible}
        closable={false}
        onCancel={() => setVisible(false)}
        onOk={onOk}
        confirmLoading={confirmLoading}
      >
        <div className="voice-list-rename">
          <div className="rename-title">重命名</div>
          <div className="rename-input">
            <Form form={form}>
              <Form.Item rules={[{required: true, message: '请输入新的名称'}]} label="" field="name"
                         wrapperCol={{span: 24}}>
                <Input></Input>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Modal>
    </div>
  )
}
